import { render, staticRenderFns } from "./wire.vue?vue&type=template&id=09e2a706"
import script from "./wire.vue?vue&type=script&lang=js"
export * from "./wire.vue?vue&type=script&lang=js"
import style0 from "./wire.vue?vue&type=style&index=0&id=09e2a706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports